import { render, staticRenderFns } from "./AuthorsWidgets.vue?vue&type=template&id=a73b2166&scoped=true"
import script from "./AuthorsWidgets.vue?vue&type=script&lang=js"
export * from "./AuthorsWidgets.vue?vue&type=script&lang=js"
import style0 from "./AuthorsWidgets.vue?vue&type=style&index=0&id=a73b2166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73b2166",
  null
  
)

export default component.exports